import React from 'react';
import {IMultiSelectProps, ISelectProps, MultiSelectInput, SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {TableSortDirection} from '~/components/Table';
import {Intent} from '~/lib/intent';
import {useResource} from '~/lib/loader';
import {ID} from '~/lib/model';
import {sortByString} from '~/lib/sort';
import {fetchAllSellers} from '~/modules/Clients/api';

type ISelectAgencyProps = Omit<ISelectProps<ID>, 'items'>;

export const SelectSeller = ({
    disabled,
    ...props
}: ISelectAgencyProps) => {
    const { resource = [], isPending } = useResource(() => fetchAllSellers(), []);

    return (
        <SelectInput 
            {...props}
            disabled={disabled || isPending}
            rightIcon={isPending && !disabled && <i className='fa fa-spinner fa-spin' />}
            items={sortByString(resource.map(seller => ({
                label: seller.name,
                value: seller.id
            })), 'label', TableSortDirection.ASC)}
        />
    );
};

export const SelectSellerField = (props: IFieldProps<ISelectAgencyProps>) => <FormField {...props}>
    <SelectSeller {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;

type IMultiSelectSellerProps = Omit<IMultiSelectProps<ID>, 'items'>;

export const MultiSelectSeller = ({
    disabled,
    ...props
}: IMultiSelectSellerProps) => {
    const {resource, isPending} = useResource(() => fetchAllSellers(), []);
    return <MultiSelectInput {...props} disabled={disabled || isPending}
        rightIcon={isPending && <i className='fa fa-spinner fa-spin'/>}
        items={sortByString(resource.map(seller => ({
            label: seller.name,
            value: seller.id
        })), 'label', TableSortDirection.ASC)}/>;
};

export const MultiSelectSellerField = (props: IFieldProps<ISelectAgencyProps>) => <FormField {...props}>
    <MultiSelectSeller {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
